var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.408,
    height: 9.951,
    viewBox: "0 0 15.408 9.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "angle-down",
    d: "M6.84,162.361.29,155.811a1.151,1.151,0,0,1,0-1.633l1.089-1.089a1.151,1.151,0,0,1,1.633,0l4.643,4.643L12.3,153.09a1.151,1.151,0,0,1,1.633,0l1.089,1.089a1.151,1.151,0,0,1,0,1.633l-6.551,6.551a1.145,1.145,0,0,1-1.628,0Z",
    transform: "translate(0.05 -152.75)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDown);
export default __webpack_public_path__ + "static/media/angle-down.5b8b5dccea72716c8250f86958a8a48c.svg";
export { ForwardRef as ReactComponent };